import React from 'react';
import styles from './styles.module.css';
import { BODY_MEASURES, BODY_MEASURE_GROUP, BODY_MEASURE_GROUPS } from '../../modules/bodyMeasures';
import { getSkinfoldProtocol } from './bodyComposition';
import { computeDelta, formatDelta, formatMeasure, getValue } from './bodyMeasurementsMath';

/**
 * Medidas que não têm lugar na silhueta (braço contraído, dobras cutâneas,
 * diâmetros ósseos), agrupadas abaixo dela. Só aparece o que tem valor.
 * Nas dobras, o título traz o protocolo usado.
 */
const BodyExtraMeasures = ({ current, reference }) => {
  const groups = BODY_MEASURE_GROUPS
    .filter((group) => group.key !== BODY_MEASURE_GROUP.INDICATORS)
    .map((group) => ({
      ...group,
      items: BODY_MEASURES
        .filter((measure) => measure.group === group.key && !measure.anchor)
        .map((measure) => {
          const value = getValue(current, measure.key);
          if (value === null) return null;
          const delta = reference ? computeDelta(value, getValue(reference, measure.key)) : null;
          return { key: measure.key, label: measure.label, value: formatMeasure(value, measure.key), delta: formatDelta(delta, measure.key) };
        })
        .filter(Boolean),
    }))
    .filter((group) => group.items.length > 0);

  if (groups.length === 0) return null;
  const protocol = getSkinfoldProtocol(current.skinfoldProtocol);

  return (
    <div className={styles.extras}>
      {groups.map((group) => (
        <div key={group.key} className={styles.extrasGroup}>
          <span className={styles.extrasTitle}>
            {group.key === BODY_MEASURE_GROUP.LIMBS ? 'Outras circunferências' : group.label}
            {group.key === BODY_MEASURE_GROUP.SKINFOLDS && protocol && <span className={styles.extrasHint}>{protocol.label}</span>}
          </span>
          <div className={styles.extrasGrid}>
            {group.items.map((item) => (
              <div key={item.key} className={styles.mobileMeasure}>
                <span className={styles.mobileMeasureLabel}>{item.label}</span>
                <span className={styles.mobileMeasureValue}>{item.value}</span>
                {item.delta && <span className={styles.mobileMeasureDelta}>{item.delta}</span>}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default BodyExtraMeasures;
